module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.contractAggregate) ? _c('div', {
    staticClass: "modal fade modal-aggregate",
    staticStyle: {
      "width": "100%",
      "left": "5%"
    },
    attrs: {
      "id": "modal-aggregate",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modal-aggregate-label",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }],
    staticClass: "modal-content",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.step == 0) ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn",
    class: {
      'active': _vm.aggregateType == 'cnpj'
    },
    on: {
      "click": function($event) {
        return _vm.handleAggregate('cnpj')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aggregateType),
      expression: "aggregateType"
    }],
    attrs: {
      "type": "radio",
      "disabled": "",
      "name": "options",
      "id": "cnpj",
      "value": "cnpj"
    },
    domProps: {
      "checked": _vm.aggregateType == 'cnpj',
      "checked": _vm._q(_vm.aggregateType, "cnpj")
    },
    on: {
      "change": function($event) {
        _vm.aggregateType = "cnpj"
      }
    }
  }), _vm._v(" CNPJ\n           ")]), _vm._v(" "), _c('label', {
    staticClass: "btn",
    class: {
      'active': _vm.aggregateType == 'cpf'
    },
    on: {
      "click": function($event) {
        return _vm.handleAggregate('cpf')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aggregateType),
      expression: "aggregateType"
    }],
    attrs: {
      "type": "radio",
      "disabled": "",
      "name": "options",
      "id": "cpf",
      "value": "cpf"
    },
    domProps: {
      "checked": _vm.aggregateType == 'cpf',
      "checked": _vm._q(_vm.aggregateType, "cpf")
    },
    on: {
      "change": function($event) {
        _vm.aggregateType = "cpf"
      }
    }
  }), _vm._v(" CPF\n           ")])]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "modal-aggregate-label"
    }
  }, [_vm._v("Cadastro Agregador")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "wizard margin-b20 "
  }, [_c('li', {
    class: {
      active: _vm.step == 0, past: _vm.step > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('big', [_vm._v("Dados pessoais")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 1, past: _vm.step > 1
    }
  }, [_vm._m(1), _vm._v(" "), _c('big', [_vm._v("Endereço")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 2, past: _vm.step > 2
    }
  }, [_vm._m(2), _vm._v(" "), _c('big', [_vm._v("Dados do veículo")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step == 3, past: _vm.step > 3
    }
  }, [_vm._m(3), _vm._v(" "), _c('big', [_vm._v("Vincular TAG")])], 1)])]), _vm._v(" "), (_vm.step == 0 && _vm.aggregateType == 'cpf') ? _c('user', {
    ref: "accountData",
    attrs: {
      "user": _vm.user,
      "contact": _vm.contact
    },
    on: {
      "addressExists": _vm.addressExists
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 0 && _vm.aggregateType == 'cnpj') ? _c('company', {
    ref: "accountData",
    attrs: {
      "company": _vm.company,
      "contact": _vm.contact
    },
    on: {
      "addressExists": _vm.addressExists
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('address-data', {
    ref: "addressData",
    attrs: {
      "address": _vm.address
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('div', {
    staticClass: "vehicle-data"
  }, [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Dados do veículo")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('plate')
    }
  }, [_c('label', {
    attrs: {
      "for": "plate"
    }
  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-plate",
      rawName: "v-mask-plate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|plateValid|plateExist'),
      expression: "'required|plateValid|plateExist'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control text-uppercase",
    attrs: {
      "type": "text",
      "name": "plate",
      "id": "plate",
      "value": "",
      "data-vv-validate-on": "blur",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "input": _vm.onPlateInput,
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('plate')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Marca")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-vehicle",
    attrs: {
      "options": _vm.brands,
      "value": _vm.brandId
    },
    on: {
      "itemSelected": _vm.onBrandSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-vehicle",
    attrs: {
      "options": _vm.models,
      "value": _vm.modelId
    },
    on: {
      "itemSelected": _vm.onModelSelected
    },
    model: {
      value: (_vm.modelId),
      callback: function($$v) {
        _vm.modelId = $$v
      },
      expression: "modelId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Eixos")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-vehicle",
    attrs: {
      "options": _vm.axes,
      "value": _vm.axesId
    },
    model: {
      value: (_vm.axesId),
      callback: function($$v) {
        _vm.axesId = $$v
      },
      expression: "axesId"
    }
  })], 1), _vm._v(" "), (_vm.plateValida) ? _c('div', {
    staticClass: "transportador-container"
  }, [_c('label', {
    staticClass: "transportador-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.souTransportador),
      expression: "souTransportador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.souTransportador) ? _vm._i(_vm.souTransportador, null) > -1 : (_vm.souTransportador)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.souTransportador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.souTransportador = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.souTransportador = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.souTransportador = $$c
        }
      }, _vm.onTransportadorToggle]
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sou transportador e quero receber VPO.")])]), _vm._v(" "), (_vm.souTransportador) ? _c('div', {
    staticClass: "antt-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "antt-input-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpfCnpjTransportador),
      expression: "cpfCnpjTransportador"
    }],
    staticClass: "form-control cpf-cnpj-input",
    attrs: {
      "type": "text",
      "name": "cpfCnpjTransportador",
      "placeholder": "Digite o número CPF ou CNPJ do proprietário",
      "maxlength": "18",
      "spellcheck": "false",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.cpfCnpjTransportador)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cpfCnpjTransportador = $event.target.value
      }, _vm.onCpfCnpjInput]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "consultar-antt-button",
    attrs: {
      "type": "button",
      "disabled": _vm.anttLoading || !_vm.cpfCnpjValido || _vm.anttStatus === 'error'
    },
    on: {
      "click": _vm.consultarAntt
    }
  }, [(_vm.anttLoading) ? _c('span', {
    staticClass: "antt-spinner"
  }) : _vm._e(), _vm._v("\n                   " + _vm._s(_vm.anttLoading ? "Consultando..." : "Consultar na ANTT") + "\n                 ")])]), _vm._v(" "), (_vm.anttStatus === 'success') ? _c('div', {
    staticClass: "antt-feedback-success"
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_166_8935_agg)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.3502 7.50011C16.6927 9.18109 16.4486 10.9287 15.6586 12.4515C14.8686 13.9742 13.5804 15.1802 12.0088 15.8681C10.4373 16.5561 8.67743 16.6845 7.02269 16.2319C5.36794 15.7793 3.91836 14.7732 2.91567 13.3812C1.91298 11.9892 1.41781 10.2955 1.51271 8.58265C1.60762 6.86977 2.28687 5.24118 3.4372 3.96849C4.58753 2.6958 6.1394 1.85594 7.83401 1.58895C9.52863 1.32197 11.2636 1.64401 12.7495 2.50136M6.74976 8.24976L8.99976 10.4998L16.4998 2.99976",
      "stroke": "#4CAF50",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_166_8935_agg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "18",
      "height": "18",
      "fill": "white"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Transportador validado com sucesso na ANTT.")])]) : _vm._e(), _vm._v(" "), (_vm.anttStatus === 'error') ? _c('div', {
    staticClass: "antt-feedback-error"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "22",
      "viewBox": "0 0 20 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_166_9400_agg)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.0001 20.3332C14.6025 20.3332 18.3334 16.6022 18.3334 11.9998C18.3334 7.39746 14.6025 3.6665 10.0001 3.6665C5.39771 3.6665 1.66675 7.39746 1.66675 11.9998C1.66675 16.6022 5.39771 20.3332 10.0001 20.3332Z",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 8.6665V11.9998",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 15.3335H10.0083",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_166_9400_agg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white",
      "transform": "translate(0 2)"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Não foi possível validar na ANTT. Verifique se os dados estão corretos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrarAvisoAntt && _vm.transportadorPendente) ? _c('div', {
    staticClass: "antt-aviso"
  }, [_vm._v("\n                 Valide o transportador na ANTT para continuar.\n               ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.vehiclesSaved) ? _c('div', {
    staticClass: "vehicle-list"
  }, [(_vm.msgError) ? _c('p', {
    staticClass: "alert alert-danger margin-b10"
  }, [_vm._v(_vm._s(_vm.msgError))]) : _vm._e(), _vm._v(" "), (_vm.vehicles.length > 0) ? _c('div', _vm._l((_vm.vehicles), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "inline plate-box"
    }, [_c('p', {
      staticClass: "cell-plate info-car"
    }, [_c('span', [_vm._v(_vm._s(item.plate))])])]), _vm._v(" "), _c('p', {
      staticClass: "inline bold border-right-gray"
    }, [_vm._v(_vm._s(item.model.brand.name))]), _vm._v(" "), _c('p', {
      staticClass: "inline"
    }, [_vm._v(_vm._s(item.categoryAxes.name))]), _vm._v(" "), _c('i', {
      staticClass: "icomoon-delete",
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-add",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.vehiclesSaved = false;
      }
    }
  }, [_c('i', {
    staticClass: "icomoon-add-circle-outline"
  }), _vm._v("\n             Adicionar veículo\n           ")])]) : _vm._e(), _vm._v(" "), (_vm.step == 3) ? _c('div', [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Ativar TAG")]), _vm._v(" "), _vm._l((_vm.vehiclesActive), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "vehicle-box"
    }, [_c('tag', {
      attrs: {
        "vehicle": item,
        "completeData": false
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.step == 4) ? _c('div', {}, [_c('div', {
    staticClass: "content-box success text-center"
  }, [_c('h4', [_vm._v("Agregador cadastrado com sucesso!")]), _vm._v(" "), _c('img', {
    staticClass: "margin-10",
    attrs: {
      "src": "/static/Icon-check-circle.svg",
      "alt": "icon-check-circle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()], 1), _vm._v(" "), (_vm.step != 4) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 0),
      expression: "step == 0"
    }],
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), (_vm.step != 2 && _vm.step != 0) ? _c('button', {
    staticClass: "no-btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_vm._v("Voltar")]) : (_vm.step == 2 && _vm.vehiclesSaved) ? _c('button', {
    staticClass: "no-btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backStep()
      }
    }
  }, [_vm._v("Voltar")]) : (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('button', {
    staticClass: "no-btn blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.vehiclesSaved = !_vm.vehiclesSaved
      }
    }
  }, [_vm._v("Voltar")]) : _vm._e(), _vm._v(" "), (_vm.step < 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n           Avançar\n           "), _c('i', {
    staticClass: "icon-circle-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && !_vm.vehiclesSaved) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("\n           Salvar\n           "), _c('i', {
    staticClass: "icon-tick"
  })]) : _vm._e(), _vm._v(" "), (_vm.step == 2 && _vm.vehiclesSaved) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.vehicles.length == 0,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doRequest()
      }
    }
  }, [_vm._v("\n           Salvar\n           "), _c('i', {
    staticClass: "icon-tick"
  })]) : _vm._e(), _vm._v(" "), (_vm.step > 2) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n           Concluir cadastro\n           "), _c('i', {
    staticClass: "icon-tick"
  })]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-step"
  }, [_c('i', {
    staticClass: "icon-tick"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "cpf-cnpj-label",
    attrs: {
      "for": "cpfCnpjTransportador"
    }
  }, [_vm._v("\n                 CNPJ ou CPF do transportador"), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-261fcb64!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/modal-aggregate-register.vue
// module id = 2069
// module chunks = 1